<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../../services/http';
	//Stores
		//Design system components
	import { Checkbox, Slider, Button, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../../types/Device';

	$: settingsStore = getDeviceSettings(id);
	export let device: Device;

	let id = real_id(device.id),
		settings = $settingsStore,
		enable = settings.vibration_enabled,
		vibration_sensitivity = settings.vibration_sensitivity,
		waitForResponse = false;

	const save = async () => {
		waitForResponse = true;
		const res = [
			await postReq(`/device/${device.category}/settings/vibration`, {
				id,
				enable,
			}),
			await postReq(`/device/${device.category}/settings/vibration_sensitivity`, {
				id,
				vibration_sensitivity,
			}),
		];
		onSettingsResponse(res, device);
		waitForResponse = false;
	};
	const a11yProps = {
		sliderValueText: $format('current_sensitivity_value', {
			values: { value: vibration_sensitivity },
			default: `Current sensitivity value is ${vibration_sensitivity}`,
		}),
		ariaLabel: $format('label_set_sensitivity_property', { default: 'Set Sensitivity property' }),
		ariaLabelValue: $format('current_sensitivity_value', {
			values: { value: vibration_sensitivity },
			default: `Current sensitivity value is ${vibration_sensitivity}`,
		}),
	};
</script>

<Checkbox class="mb-s" size="m" bind:checked={enable} id="checkbox-tg4x20z"
	>{$format('vibration_enable', {
		default: 'Enable vibration detection (only when the door/window is closed)',
	})}</Checkbox
>

<Text class="mb-s" styleType="body-small"
	>{$format('vibration_sens_label')}
	{vibration_sensitivity + '%'}</Text
>

<Slider
	id="slider-9vkgzrk"
	{a11yProps}
	class="mb-s"
	disabled={!enable || waitForResponse}
	type="horizontal"
	bind:value={vibration_sensitivity}
/>

<Button loading={waitForResponse} size="m" class="text-uppercase" width="full" on:click={save}
	>{$format('button_apply', { default: 'apply' })}</Button
>
